module.exports = __webpack_public_path__ + "img/banner98.cfd0d680.png";